/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect} from 'react'
import {isNotEmpty, KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link, useNavigate, useParams} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import swal from 'sweetalert'
import {CloseButton, Spinner} from 'react-bootstrap'
import AddRemoveJadwal from './AddRemoveJadwal'
import {useTranslation, initReactI18next} from 'react-i18next'
import {getAccesses, nonSalesList} from '../../../api/modules/order'
import {getOrderDetail, approveOtorisator, getScheduleOrder} from '../../../api/modules/order'
import Accordion from 'react-bootstrap/Accordion'
import {create, getFile, deleteFile, getFileByOrder} from '../../../api/modules/file'
import {getStock} from '../../../api/modules/getdatalist'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {setNotifOrder, setGetNotif} from '../../../_metronic/redux/content'
import i18next from 'i18next'
import Select from 'react-select'
import CurrencyInput from 'react-currency-input-field'
import {getCusGrup, getRoleFlagList} from '../../../api/modules/master-data/master_2'
import InputGroup from 'react-bootstrap/InputGroup'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {setItemNego} from '../../../_metronic/redux/content'
import axios from 'axios'
import {MultiSelect} from 'react-multi-select-component'
import {PopoverText} from '../../../components/Popover/Popover'
import {parse, format} from 'date-fns'
import {appSelector} from '../../../redux/slices/appSlices'
import {useAppSelector} from '../../../redux/hooks'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {isUndefined} from 'util'
import {authSelector} from 'src/redux/slices/authSlices'
import {AnyARecord} from 'dns'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import dateformat from 'src/utils/dateformat'
import { handleDownloadAttachment } from 'src/app/helpers/file'

const ApprovalOrderDetail: React.FC = () => {
  const intl = useIntl()
  const {roleId} = useAppSelector(authSelector)
  const hakAkses = HakAkses()
  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)
  const [show3, setShow3] = useState(false)
  const [show4, setShow4] = useState(false)
  const [show5, setShow5] = useState(false)
  const [show6, setShow6] = useState(false)
  const params = useParams()
  const [showStock, setShowStock] = useState(false)
  const [showJadwal, setShowJadwal] = useState(false)

  const [statusAmandemen, setStatusAmandemen] = useState('')
  // console.log(statusAmandemen)

  const handleShowAttachment = async (paramm: any, id: any) => {
    if (paramm == 'header') ambilAttachment(paramm, params.id)
    else ambilAttachment(paramm, id)
    setShowUpload(true)
  }
  const handleShowJadwal = async (id: any, param: any) => {
    const res = await getScheduleOrder(id, param)
    setAllJadwal(res.data.data.schedules)
    setShowJadwal(true)
  }
  const handleClose5 = () => setShow5(false)
  const handleShow5 = () => setShow5(true)

  const handleShow6 = async () => {
    setBtnLoading(true)

    approveOtorisator(params.id, {
      order_submission_ids: itemIndex,
      lang: i18next.language,
    })
      .then((res) => {
        swal({
          title: `${t('Order Aprrove Success')}`,
          icon: 'success',
        }).then(() => {
          // window.location.reload();
          setButtonFlag(false)
          navigate('/approval/order')

          disabledCheckbox()
          disableBtn()
          setShow5(false)
          dispath(setGetNotif(!notif))
        })
      })
      .catch((error) => {
        const msg = error.response.data.message.match('approved quantum')
          ? 'Kuantum Disetujui Wajib Diisi'
          : error.response.data.message
        swal({
          title: `${t(msg)}`,
          icon: 'error',
        })
      })
      .finally(() => setBtnLoading(false))
  }
  const [allFile, setAllFiles] = useState<any[]>([])

  const [fixedQuantum2, setFixedQuantum2] = useState<any>(0)
  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum2(temp)
  }

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)
  const [btnStock, setBtnStock] = useState(false)
  const [btnProfile, setBtnProfile] = useState(false)
  const user = localStorage.getItem('role-flag')
  const notif = useSelector((state: any) => state.notif.getNotif)

  const [detailOrder, setDetailOrder] = useState<any[]>([])
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [files3, setFiles3] = useState<any>()
  const [indexAttac, setIndexAttac] = useState(0)

  const [roleUser, setRoleUser] = useState('')
  const [itemIndex, setItemIndex] = useState<any[]>([])
  const [indexItem, setIndexItem] = useState<any[]>([])
  const [buttonFlag, setButtonFlag] = useState(false)
  const [sektorID, setSektorID] = useState(0)
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [status, setStatus] = useState(0)
  const [ID, setID] = useState(0)
  const [statusOrder, setStatusOrder] = useState(0)
  const [allStock, setAllStock] = useState([])

  const dispath = useDispatch()

  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerTitle, setCustomerTitle] = useState('')
  const [orderNumber, setOrderNumber] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [PICCust, setPICCust] = useState('')
  const [emailCust, setEmailCust] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [param, setParam] = useState('')
  const [paymentTest, setPaymentTest] = useState<any>('')
  const [subOrderID, setSubOrderID] = useState(0)
  const [downloadOnly, setDownloadOnly] = useState(false)
  const [showUpload, setShowUpload] = useState(false)
  const navigate = useNavigate()

  //#region
  const [pname, setPname] = useState('')
  const [subprice, setSubprice] = useState<any>(0)
  const [subpriceApp, setSubpriceApp] = useState<any>(0)
  const [quantum, setQuantum] = useState<any>(0)
  const [quantumApp, setQuantumApp] = useState<any>(0)
  const [disctribution, setDistribution] = useState('')
  const [cusAcountGroup, setCusAcountGroup] = useState('')
  const [regarding, setRegarding] = useState('')
  const [provinceDesc, setProvinceDesc] = useState('')
  const [cityDesc, setCityDesc] = useState('')
  const [allJadwal, setAllJadwal] = useState<any[]>([])
  const [language, setLanguage] = useState<any>()

  const [tempData, setTempData] = useState<any>({})
  const [tempData2, setTempData2] = useState<any>({})
  const [tempDetail, setTempDetail] = useState<any>({})
  const [idxDetail, setIdxDetail] = useState(0)
  const [nonpenjualan, setNonPenjualan] = useState('')
  const [change, setChange] = useState(false)
  const [isDisable, setIsDisable] = useState(false)
  const [arrayEnduser, setEnduserArray] = useState([])
  const [is_amendment, setisAmandment] = useState('false')
  const [showJadwal2, setShowJadwal2] = useState(false)
  const [numberRevised, setNumberRevised] = useState(0)
  const [disableAdd, setDisableAdd] = useState(false)
  const [buttonAdd, setButtonAdd] = useState(false)
  const [custStatus, setCustStatus] = useState<any>({})
  const [nonSalesRegardingLabel, setNonSalesRegardingLabel] = useState('')
  const [showDetail, setShowDetail] = useState(false)

  const [colorList] = useState<any>({
    // Red: '#274070',
    Red: '#ff0000',
    Green: '#48CE86',
    Yellow: '#F0C94A',
    Black: '#000000',
  })

  const [totalInvoices, setTotalInvoices] = useState<any[]>([0, 0, 0, 0])

  const [invoices, setInvoices] = useState<any[]>([
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
    {
      B000: 0,
      C000: 0,
      D000: 0,
      E000: 0,
      F000: 0,
    },
  ])

  const ambilAttachment = async (paramm: any, id: any) => {
    if (paramm == 'header') {
      const res = await getFile(
        paramm,
        parseInt(sessionStorage.getItem('po')!),
        localStorage.getItem('credential')!
      )
      setAllFiles(res.data.data)
    } else if (paramm == 'order-item') {
      const res = await getFile(paramm, id, localStorage.getItem('credential')!)
      setAllFiles(res.data.data)
    } else if (paramm == 'amandemen') {
      const res = await getFile(paramm, id, localStorage.getItem('credential')!)
      setAllFiles(res.data.data)
    }
  }

  const disableBtn = () => {
    const reject = document.getElementById(`btn-reject`) as HTMLInputElement
    const approve = document.getElementById(`btn-approve`) as HTMLInputElement
    const revision = document.getElementById(`btn-revision`) as HTMLInputElement

    if (reject != null) {
      reject.disabled = true
      reject.hidden = true
    }

    if (approve != null) {
      approve.disabled = true
      approve.hidden = true
    }

    if (revision != null) {
      revision.disabled = true
      revision.hidden = true
    }
  }

  const [listAmandemen, setListAmandemen] = useState<any[]>([])
  const [keychange, setKeychange] = useState(0)

  const getDetail = async () => {
    setButtonAdd(false)
    await getOrderDetail(
      params.id,
      localStorage.getItem('credential'),
      params.type == 'all' ? 2 : 2
    ).then(async (res) => {
      setPaymentTest(res.data.data?.children[0]?.payment_type_1_desc)
      let tempArray: any[] = []
      await nonSalesList().then((response) => {
        response.data.forEach((element: any) => {
          if (element.code == res.data.data.non_sales_regarding)
            setNonSalesRegardingLabel(element.desc)
        })
      })
      setKeychange(keychange + 1)
      setDetailOrder(res.data.data?.children)
      setRegarding(res.data.data.regarding)
      setNonPenjualan(res.data.data.non_sales_regarding)
      setStatus(res.data.data.status)
      setStatusOrder(res.data.data.status)
      setID(res.data.data.id)
      setOrderNumber(res.data.data.po_number)
      setSektorID(res.data.data.sector_id)
      setCustomerCode(res.data.data.customer?.customer_code)
      setCustomerName(res.data.data.customer?.name)
      setCustomerTitle(res.data.data.customer?.title)
      setCustomerAddress(res.data.data.customer?.address)
      setPhoneNumber(res.data.data.customer?.user?.mobile_number)
      setPICCust(res.data.data.customer?.name4)
      setEmailCust(res.data.data.customer?.user?.email)
      setDistribution(res.data.data.distribution_channel)
      setCusAcountGroup(res.data.data.customer_account_group)
      setNumberRevised(res.data.data.item_revisied)
      for (let item of res.data.data.children) {
        if (item.status === 1 || item.status === 0) {
          setButtonAdd(true)
        }
      }
      const temp: any[] = []
      res.data.data.children.forEach((data: any) => {
        if (data.amendment_orders.length >= 1) temp.push(data.id)
      })

      setListAmandemen(temp)
      if (user == 'salesAdmin') {
        dispath(setGetNotif(!notif))
      }
    })
  }

  const handleProfileCustomer = () => {
    setBtnProfile(true)
    const curpo_AllAndalan = async () => {
      let tempaging: any[] = []
      let tempoutstanding: any[] = []
      let tempinvoices: any[] = invoices
      let temptotal: any[] = totalInvoices
      const res = await axios.get(
        `${process.env.REACT_APP_PI_BACKEND_API_MASTERDATA}/customer/profiling/${customerCode}`
      )

      res.data.data.forEach((element: any) => {
        if (element.type == 'aging') tempaging.push(element)
        else if (element.type == 'outstanding so') tempoutstanding.push(element)
        else if (element.type == 'status') {
          // console.log(JSON.stringify(element))
          setCustStatus(element)
        }
      })
      if (tempaging.length > 0) {
        tempaging.forEach((element) => {
          if (element.Aging == '0 - 30 days') {
            if (element.CompanyCode == 'B000') tempinvoices[0].B000 += 1
            else if (element.CompanyCode == 'C000') tempinvoices[0].C000 += 1
            else if (element.CompanyCode == 'D000') tempinvoices[0].D000 += 1
            else if (element.CompanyCode == 'E000') tempinvoices[0].E000 += 1
            else if (element.CompanyCode == 'F000') tempinvoices[0].F000 += 1
          } else if (element.Aging == '31 - 90 days') {
            if (element.CompanyCode == 'B000') tempinvoices[1].B000 += 1
            else if (element.CompanyCode == 'C000') tempinvoices[1].C000 += 1
            else if (element.CompanyCode == 'D000') tempinvoices[1].D000 += 1
            else if (element.CompanyCode == 'E000') tempinvoices[1].E000 += 1
            else if (element.CompanyCode == 'F000') tempinvoices[1].F000 += 1
          } else if (element.Aging == '91 - 365 days') {
            if (element.CompanyCode == 'B000') tempinvoices[2].B000 += 1
            else if (element.CompanyCode == 'C000') tempinvoices[2].C000 += 1
            else if (element.CompanyCode == 'D000') tempinvoices[2].D000 += 1
            else if (element.CompanyCode == 'E000') tempinvoices[2].E000 += 1
            else if (element.CompanyCode == 'F000') tempinvoices[2].F000 += 1
          } else if (element.Aging == '>365 days') {
            if (element.CompanyCode == 'B000') tempinvoices[3].B000 += 1
            else if (element.CompanyCode == 'C000') tempinvoices[3].C000 += 1
            else if (element.CompanyCode == 'D000') tempinvoices[3].D000 += 1
            else if (element.CompanyCode == 'E000') tempinvoices[3].E000 += 1
            else if (element.CompanyCode == 'F000') tempinvoices[3].F000 += 1
          }
        })
      }
      tempinvoices.forEach((element: any, index: any) => {
        temptotal[index] += element.B000
        temptotal[index] += element.C000
        temptotal[index] += element.D000
        temptotal[index] += element.E000
        temptotal[index] += element.F000
      })
      setInvoices(tempinvoices)
      setTotalInvoices(temptotal)
    }

    curpo_AllAndalan()
      .then(() => {
        setShow2(true)
      })
      .catch((error: any) => {
        if (error.response) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        } else {
          swal({
            title: t(error.message),
            icon: 'error',
          })
        }
      })
      .finally(() => setBtnProfile(false))
  }

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }
    role()
    getAllRoleList()
    getDetail()
  }, [])

  const [day, setDay] = useState<any>(0)
  const [month, setMonth] = useState<any>(0)
  const [year, setYear] = useState<any>(0)
  const [datenow, setDateNow] = useState('')
  const [statusItem, setStatusItem] = useState(0)
  const [files, setFiles] = useState({file: null})
  const [files2, setFiles2] = useState<any>()
  const [fileBox, setFileBox] = useState<any>({})

  const clearInputUpload = () => {
    const inputPrivate1 = document.getElementById('isPrivate1') as HTMLInputElement
    if (inputPrivate1 != null) inputPrivate1.checked = false

    const inputPrivate2 = document.getElementById('isPrivate2') as HTMLInputElement
    if (inputPrivate2 != null) inputPrivate2.checked = false

    const inputPrivate3 = document.getElementById('isPrivate3') as HTMLInputElement
    if (inputPrivate3 != null) inputPrivate3.checked = false

    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    if (input1 != null) input1.value = ''
    const input1_2 = document.getElementById('uploadketerangan2') as HTMLInputElement
    if (input1_2 != null) input1_2.value = ''
    const input2 = document.getElementById('upload') as HTMLInputElement
    if (input2 != null) input2.value = ''
    const input2_2 = document.getElementById('upload2') as HTMLInputElement
    if (input2_2 != null) input2_2.value = ''
    const input2_1 = document.getElementById('upload11') as HTMLInputElement
    if (input2_1 != null) input2_1.value = ''
  }

  const removeFileState = () => {
    setFiles({file: null})
    setFiles2('')
    setNamaFile('')
    setDescription('')
    setDataType('')
    setIsPrivate(false)
    setTempRole([])
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            if (param == 'order-item') ambilAttachment(param, subOrderID)
            else ambilAttachment(param, sessionStorage.getItem('po'))
          })
          .catch((error) => {
            swal({
              title: t(error.response.data),
              icon: 'error',
            })
          })
      }
    })
  }

  const disabledCheckbox = () => {
    indexItem.forEach((element: any) => {
      const isChecked = document.getElementById(`checkbox${element}`) as HTMLInputElement
      if (isChecked != null) isChecked.disabled = true
    })
    setIndexItem([])
    setItemIndex([])
  }

  const [amandemenPresent, setAmandemenPresent] = useState(false)

  const onclickCheckBox = (index: any) => {
    const isChecked = document.getElementById(`checkbox${index}`) as HTMLInputElement
    const temp = isChecked.value.split('~#~')

    const tempIndex: string[] = indexItem
    const tempArray: string[] = itemIndex
    if (isChecked.checked) {
      tempArray.push(temp[0])
      tempIndex.push(temp[1])

      setItemIndex(tempArray)
      setIndexItem(tempIndex)
    } else {
      const selectedtempArray = tempArray.indexOf(temp[0])
      const selectedIndexindex = tempIndex.indexOf(temp[1])
      tempArray.splice(selectedtempArray, 1)
      tempIndex.splice(selectedIndexindex, 1)
      setItemIndex(tempArray)
      setIndexItem(tempIndex)
    }
    tempArray.forEach((data: any) => {
      let temp = 0
      temp = listAmandemen.findIndex((item: any) => item == data)
      if (temp != 0) {
        setAmandemenPresent(true)
        return
      } else {
        setAmandemenPresent(false)
      }
    })

    // console.log(amandemenPresent)
    if (tempIndex.length != 0) setButtonFlag(true)
    else setButtonFlag(false)
  }

  const handleStock = async () => {
    setBtnStock(true)
    const temp = {order_sub_details: [{}]}
    temp.order_sub_details.splice(0, 1)
    detailOrder.forEach((data) => {
      if (data.is_amendment == true)
        temp.order_sub_details.push({
          material_number: data.amendment_orders[0]?.material_number,
          plant: data.amendment_orders[0]?.plant,
        })
      else temp.order_sub_details.push({material_number: data.material_number, plant: data.plant})
    })

    getStock(temp)
      .then((res) => {
        setAllStock(res.data.data)
        setShowStock(true)
      })
      .catch((error: any) => {
        if (error.response) {
          swal({
            title: t(error.response.data.message),
            icon: 'error',
          })
        } else {
          swal({
            title: t(error.message),
            icon: 'error',
          })
        }
      })
      .finally(() => setBtnStock(false))
  }
  let productTypeDetail = ''
  let regionDetail = ''
  let produsenDetail = ''

  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  function download_file(fileURL: any, fileName: any) {
    var save = document.createElement('a')
    save.href = fileURL
    save.target = '_blank'
    // var filename = fileURL.substring(fileURL.lastIndexOf('/') + 0)
    let temp = fileName.split('.')
    var filename = temp[0]
    // console.log(filename.slice(1, 20))
    // save.download = filename.slice(1, 20)
    save.download = filename
    if (
      navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
      navigator.userAgent.search('Chrome') < 0
    ) {
      document.location = save.href
    } else {
      var evt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: false,
      })
      save.dispatchEvent(evt)
      ;(window.URL || window.webkitURL).revokeObjectURL(save.href)
    }
  }

  //accsess delete fileBox
  const accsessDelete = useSelector(
    (state: any) => state.appPersistedReducer.selectedMenu.attachment_delete
  )

  const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]

  function getDaysInMonth(year: any, month: any) {
    return new Date(year, month, 0).getDate()
  }

  function loopTanggal(jumlah: any) {
    var indents = []
    for (let i = 0; i < jumlah; i++) {
      indents.push(<option value={i + 1}>{i + 1}</option>)
    }
    return indents
  }

  const [temporaryIndex, setTemporaryIndex] = useState(0)

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const handleShowValue = (enduser: any, multipleend: any) => {
    if (multipleend) {
      let temparray: any[] = enduser.split(',')
      let temp = ''
      temparray.forEach((element: any, index: any) => {
        if (index + 1 == temparray.length) temp = temp + element
        else temp = temp + element + ', '
      })
      return temp
    } else return ''
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const nonPurchaseButPurchase = (regarding == 'PO002' && ['INF-201', 'INF-202'].includes(nonpenjualan))
  const showPurchaseForm = regarding == 'PO001' || nonPurchaseButPurchase

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {sessionStorage.getItem('amandemen')! == 'true'
          ? t('MANAGEMENT_ORDER_DETAIL_AMANDEMENT.TITLE')
          : t('MANAGEMENT_ORDER_DETAIL.TITLE')}
      </PageTitle>
      <div className='card' key={keychange}>
        {/* begin::Header */}
        <div className='card-body'>
          <Row>
            <Col md={6}>
              <Row className='mb-3'>
                <Col lg={5}>
                  <p className='fs-4'>{t('order-perihal')}</p>
                </Col>
                <Col lg={7} key={nonSalesRegardingLabel}>
                  {regarding == 'PO002' ? (
                    <Form.Control
                      value={t('Non-penjualan') + ' - ' + nonSalesRegardingLabel}
                      disabled
                      size='sm'
                    />
                  ) : (
                    <Form.Control value={t('penjualan')} disabled size='sm' />
                  )}
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={5}>
                  <p className='fs-4 mt-2'>{t('Customer Name')}</p>
                </Col>
                <Col md={7}>
                  <Form.Control type='text' value={customerName} disabled size='sm' />
                </Col>
              </Row>

              <Row className='mb-3'>
                <Col lg={5}>
                  <p className='fs-4 mt-2'>{t('Customer Number')}</p>
                </Col>
                <Col lg={7}>
                  <Form.Control type='text' value={customerCode} disabled size='sm' />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col lg={5}>
                  <p className='fs-4'>{t('order-lampiran')}</p>
                </Col>
                <Col lg={7}>
                  <Button
                    variant='primary'
                    onClick={() => {
                      setisAmandment('false')
                      handleShowAttachment('header', params.id)
                      setParam('header')
                      setDownloadOnly(true)
                    }}
                  >
                    {t('order-lampiran')}
                  </Button>
                </Col>
              </Row>
              {regarding == 'PO002' && roleUser == 'salesAdmin' && (
                <Row className='mb-3'>
                  <Col lg={5}>
                    <p className='fs-4'>{t('order-lampiran')} Order Items</p>
                  </Col>
                  <Col lg={7}>
                    <Button variant='primary' onClick={() => ''}>
                      {t('order-lampiran')}
                    </Button>
                  </Col>
                </Row>
              )}
              <Row className='mb-3'>
                <Col lg={5}>
                  <p className='fs-4'>{t('Customer Support Data')}</p>
                </Col>
                <Col lg={7}>
                  <div className='d-flex align-items-center'>
                    <Button
                      className='btn btn-primary'
                      disabled={btnProfile}
                      onClick={() => handleProfileCustomer()}
                    >
                      {btnProfile ? (
                        <Spinner animation='border' variant='light' size='sm' />
                      ) : (
                        <>{t('order-lihat')}</>
                      )}
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col lg={5}>
                  <p className='fs-4'>{t('order-reqHarga')}</p>
                </Col>
                <Col lg={7}>
                  <Button className='btn btn-primary' disabled>
                    {t('order-lihat')}
                  </Button>
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col lg={5}>
                  <p className='fs-4'>{t('order-cekStock')}</p>
                </Col>
                <Col lg={7}>
                  <Button variant='primary' disabled={btnStock} onClick={() => handleStock()}>
                    {btnStock ? (
                      <Spinner animation='border' variant='light' size='sm' />
                    ) : (
                      <>{t('order-lihat')}</>
                    )}
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className='mb-3'>
                <Col lg={4}>
                  <p className='fs-4 mt-2'>{t('Order Number')}</p>
                </Col>
                <Col lg={8}>
                  <Form.Control
                    type='text'
                    value={orderNumber == '' ? '' : '10' + orderNumber}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>

              <Row className='mb-3'>
                <Col md={4}>
                  <p className='fs-4 mt-2'>{t('Address')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control as='textarea' value={customerAddress} disabled size='sm' />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={4}>
                  <p className='fs-4 mt-2'>{t('Phone Number')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control value={phoneNumber} disabled size='sm' />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={4}>
                  <p className='fs-4 mt-2'>{t('Email')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control value={emailCust} disabled size='sm' />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md={4}>
                  <p className='fs-4 mt-2'>{t('PIC Customer')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control value={PICCust} disabled size='sm' />
                </Col>
              </Row>
            </Col>
          </Row>

          <div className='table-responsive bdr'>
            {/* Table Head */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              {showPurchaseForm ? (
                <>
                  <thead className='border-bottom'>
                    <tr className='fw-bold  d-flex jusify-content-center w-100 align-items-center'>
                      <th className='td-order-1 text-center'>{t('pilih')}</th>
                      <th className='td-order-1 text-center'>{t('sub-order-item')}</th>
                      <th className='td-order-2 text-center'>Status</th>
                      <th className='td-order-4 text-center'>{t('order-aksi')}</th>
                      <th className='td-order-4 text-center'>Sales Org</th>
                      <th className='td-order-2 text-center'>{t('sub-order-incoterm')}</th>
                      <th className='td-order-3 text-center'>{t('sub-order-wilayah')}</th>
                      {sektorID == 1 && <th className='td-order-2 text-center'>{t('segment')}</th>}
                      <th className='td-order-3 text-center'>{t('End Customer')}</th>
                      <th className='td-order-2 text-center'>{t('sub-order-jenis')}</th>
                      <th className='td-order-2 text-center'>{t('Product Code')}</th>
                      <th className='td-order-4 text-center'>{t('sub-order-produk')}</th>
                      <th className='td-order-2 text-center'>{t('sub-order-spek')}</th>
                      <th className='td-order-2 text-center'>{t('Kuantum Pengajuan')}</th>
                      {sektorID != 2 && (
                        <th className='td-order-2 text-center'>{t('Kuantum PengajuanD')}</th>
                      )}
                      <th className='td-order-2 text-center'>{t('Harga Pengajuan')}</th>
                      {sektorID != 2 && (
                        <th className='td-order-2 text-center'>{t('sub-order-hargaD')}</th>
                      )}
                      {sektorID == 1 ? (
                        <th className='td-order-2 text-center'>Status {t('Price')}</th>
                      ) : (
                        ''
                      )}
                      {sektorID == 2 ? (
                        <th className='td-order-3 text-center'>{t('sub-order-gudang')}</th>
                      ) : (
                        ''
                      )}
                    </tr>
                  </thead>
                  {detailOrder.map((item, _index) => (
                    <tbody key={item?.id ?? _index}>
                      {(item.sector_id == 2 || item.sector_id == 4) ? (
                        <>
                          <tr className='d-flex jusify-content-center w-100 align-items-center'>
                            <td className='td-order-1 text-center column'>
                              <div className='d-block py-3' style={{margin: '-1px 0 auto'}}>
                                <input
                                  disabled={item.status == 14 ? false : true}
                                  className='form-check-input'
                                  type='checkbox'
                                  id={'checkbox' + _index}
                                  value={item.id}
                                  onClick={() => onclickCheckBox(_index)}
                                />
                              </div>
                            </td>

                            <td className='td-order-1 text-center column'>
                              <span className='d-block fs-6 py-3'>{_index + 1}</span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3' style={{margin: '-.3px 0 -.3px'}}>
                                {item['status_text'] == 'Pengajuan Amandemen' ||
                                item['status_text'] == 'Amandemen' ||
                                item['status_text'] == 'Diamandemen Customer' ||
                                item['status_text'] == 'Telah Diamandemen' ||
                                item['status_text'] == 'Menunggu Persetujuan Amandemen' ? (
                                  <span className='badge badge-light-info'>{t('Amandemen')}</span>
                                ) : item['status'] == '0' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '1' && item.is_new ? (
                                  <label className='opacity-0'>-</label>
                                ) : item['status'] == '1' ? (
                                  <span className='badge badge-light-primary'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '2' ? (
                                  <span className='badge badge-light-warning'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '3' ? (
                                  <span className='badge badge-light-warning'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '4' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '5' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '6' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '7' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : (
                                  <span className='badge badge-light-danger'>
                                    {t(item['status_text'])}
                                  </span>
                                )}
                              </span>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <div className='d-flex justify-content-center align-items-center'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title='Detail'
                                  onClick={() => {
                                    setisAmandment('false')
                                    setTempDetail(item)
                                    setShowDetail(true)
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/file-text-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                <button
                                  onClick={() => {
                                    setisAmandment('false')
                                    setSubOrderID(item.id)
                                    setParam(item.is_new_item ? 'amandemen' : 'order-item')
                                    setFileBox(item)
                                    setStatusAmandemen(item.status_text)
                                    setDownloadOnly(true)
                                    handleShowAttachment(
                                      item.is_new_item ? 'amandemen' : 'order-item',
                                      item.id
                                    )
                                  }}
                                  // disabled={item.status_text == "Telah Diamandemen" ? true : false}
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('order-lampiran')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/archive-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('Jadwal')}
                                  onClick={() => {
                                    setProvinceDesc(item.province?.region_name)
                                    setCityDesc(item.city?.city_name)
                                    setPname(item.product_name)
                                    formattingTon(item.fixed_quantum)
                                    setisAmandment('false')
                                    setSubOrderID(item.id)
                                    handleShowJadwal(
                                      item['id'],
                                      item.is_new_item ? 'true' : 'false'
                                    )
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/calendar-check-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              </div>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <span className='d-block fs-6 py-3'>{item.produsen?.name}</span>
                            </td>
                            {item.sector?.id == 2 ? (
                              <>
                                {item.incoterm2 == null ? (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                      {item.incoterm1?.code}-{item.incoterm2_id}
                                    </span>
                                  </td>
                                ) : (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                      {item.incoterm1?.code}-{item.incoterm2?.code}
                                    </span>
                                  </td>
                                )}
                              </>
                            ) : (
                              <>
                                {item.incoterm2 == null ? (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                      {item.incoterm2_id == null ||
                                      item.incoterm2_id == '0' ||
                                      item.incoterm2_id == ''
                                        ? ''
                                        : '-' + item.incoterm2_id}
                                    </span>
                                  </td>
                                ) : (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                      {item.incoterm1?.code}-{item.incoterm2?.code}
                                    </span>
                                  </td>
                                )}
                              </>
                            )}
                            <td className='td-order-3 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                <PopoverText
                                  content={
                                    item['province']?.region_name +
                                    (item['city']?.city_name ? ', ' + item['city']?.city_name : '')
                                  }
                                  index={_index}
                                  className='spec-sliceee'
                                />
                              </span>
                            </td>
                            {sektorID == 1 && (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>{t(item.segment_name)}</span>
                              </td>
                            )}
                            <td className='td-order-3 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                <PopoverText
                                  content={
                                    item?.end_user_multiple
                                      ? handleShowValue(item?.end_user, item?.end_user_multiple)
                                      : item?.end_user
                                  }
                                  index={_index}
                                  className='desc-slicee'
                                />
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>{item['product_type_desc']}</span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {parseInt(item.material_number) == 0 ? (
                                  <label className='opacity-0'>-</label>
                                ) : (
                                  item['material_number']?.slice(-7)
                                )}
                              </span>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <span className='d-block fs-6 py-3'>{item['product_name']}</span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              {item['product_spec'] ? (
                                <span className='d-block fs-6 py-3'>
                                  <PopoverText
                                    content={item['product_spec']}
                                    index={_index}
                                    className='spec-sliceee'
                                  />
                                </span>
                              ) : (
                                <label className='opacity-0'>-</label>
                              )}
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {i18next.language === 'en'
                                  ? item['request_quantum']?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : item['request_quantum']?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })}{' '}
                                {item.sector_id === 3 ? 'MT' : 'Ton'}
                              </span>
                            </td>
                            {sektorID != 2 && (
                              <td className='td-order-2 text-center column'>
                                {item['fixed_quantum'] ? (
                                  <span className='d-block fs-6 py-3'>
                                    {(item.status == 4 ||
                                      item.status == 7 ||
                                      item.status == 6 ||
                                      item.status == 8) &&
                                    item.sales_id != null ? (
                                      <>
                                        {i18next.language === 'en'
                                          ? item['fixed_quantum']?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : item['fixed_quantum']?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}{' '}
                                        {item.sector_id === 3 ? 'MT' : 'Ton'}
                                      </>
                                    ) : (
                                      <label className='opacity-0'>-</label>
                                    )}
                                  </span>
                                ) : (
                                  <label className='opacity-0'>-</label>
                                )}
                              </td>
                            )}
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {(sektorID == 3 ? 'USD' : 'Rp') +
                                  (i18next.language === 'en'
                                    ? item['request_price']?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : item['request_price']?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })) +
                                  (sektorID == 3 ? '/MT' : '/Ton')}
                              </span>
                            </td>
                            {sektorID != 2 && (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {(item.status == 4 ||
                                    item.status == 7 ||
                                    item.status == 6 ||
                                    item.status == 8) &&
                                  item.sales_id != null ? (
                                    <>
                                      {(sektorID == 3 ? 'USD' : 'Rp') +
                                        (i18next.language === 'en'
                                          ? item['fixed_price']?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : item['fixed_price']?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })) +
                                        (sektorID == 3 ? '/MT' : '/Ton')}
                                    </>
                                  ) : (
                                    <label className='opacity-0'>-</label>
                                  )}
                                </span>
                              </td>
                            )}
                            {item.sector_id == 2 ? (
                              <td className='td-order-3 text-center column'>
                                <div>
                                  <span className='d-block fs-6 py-3'>
                                    <PopoverText
                                      content={item['plant_desc']}
                                      index={_index}
                                      className='spec-sliceee'
                                    />
                                  </span>
                                </div>
                              </td>
                            ) : (
                              ''
                            )}
                          </tr>
                        </>
                      ) : (
                        <>
                          <tr className='d-flex jusify-content-center w-100 align-items-center'>
                            <td className='td-order-1 text-center column'>
                              <div className='d-block py-3' style={{margin: '-1px 0 auto'}}>
                                <input
                                  disabled={item.status == 14 ? false : true}
                                  className='form-check-input'
                                  type='checkbox'
                                  id={'checkbox' + _index}
                                  value={item.id}
                                  onClick={() => onclickCheckBox(_index)}
                                />
                              </div>
                            </td>

                            <td className='td-order-1 text-center column'>
                              <span className='d-block fs-6 py-3'>{_index + 1}</span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3' style={{margin: '-.3px 0 -.3px'}}>
                                {item['status_text'] == 'Pengajuan Amandemen' ||
                                item['status_text'] == 'Amandemen' ||
                                item['status_text'] == 'Diamandemen Customer' ||
                                item['status_text'] == 'Telah Diamandemen' ||
                                item['status_text'] == 'Menunggu Persetujuan Amandemen' ? (
                                  <span className='badge badge-light-info'>{t('Amandemen')}</span>
                                ) : item['status'] == '0' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '1' && item.is_new ? (
                                  <label className='opacity-0'>-</label>
                                ) : item['status'] == '1' ? (
                                  <span className='badge badge-light-primary'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '2' ? (
                                  <span className='badge badge-light-warning'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '3' ? (
                                  <span className='badge badge-light-warning'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '4' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '5' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '6' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '7' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : (
                                  <span className='badge badge-light-danger'>
                                    {t(item['status_text'])}
                                  </span>
                                )}
                              </span>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <div
                                className='d-flex justify-content-center align-items-center'
                                style={{margin: '.8px 0'}}
                              >
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title='Detail'
                                  onClick={() => {
                                    setisAmandment('false')
                                    setTempDetail(item)
                                    setShowDetail(true)
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/file-text-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                <button
                                  onClick={() => {
                                    setisAmandment('false')
                                    setSubOrderID(item.id)
                                    setParam(item.is_new_item ? 'amandemen' : 'order-item')
                                    setFileBox(item)
                                    setStatusAmandemen(item.status_text)
                                    setDownloadOnly(true)
                                    handleShowAttachment(
                                      item.is_new_item ? 'amandemen' : 'order-item',
                                      item.id
                                    )
                                  }}
                                  // disabled={item.status_text == "Telah Diamandemen" ? true : false}
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('order-lampiran')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/archive-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>

                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('Jadwal')}
                                  onClick={() => {
                                    setProvinceDesc(item.province?.region_name)
                                    setCityDesc(item.city?.city_name)
                                    setPname(item.product_name)
                                    formattingTon(item.fixed_quantum)
                                    setisAmandment('false')
                                    setSubOrderID(item.id)
                                    handleShowJadwal(
                                      item['id'],
                                      item.is_new_item ? 'true' : 'false'
                                    )
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/calendar-check-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              </div>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <span className='d-block fs-6 py-3'>{item.produsen?.name}</span>
                            </td>
                            {item.sector?.id == 2 ? (
                              <>
                                {item.incoterm2 == null ? (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                      {item.incoterm1?.code}-{item.incoterm2_id}
                                    </span>
                                  </td>
                                ) : (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                      {item.incoterm1?.code}-{item.incoterm2?.code}
                                    </span>
                                  </td>
                                )}
                              </>
                            ) : (
                              <>
                                {item.incoterm2 == null ? (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                      {item.incoterm1?.code}
                                      {item.incoterm2_id == null ||
                                      item.incoterm2_id == '0' ||
                                      item.incoterm2_id == ''
                                        ? ''
                                        : '-' + item.incoterm2_id}
                                    </span>
                                  </td>
                                ) : (
                                  <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                      {item.incoterm1?.code}
                                      {item.incoterm2?.code ? '-' + item.incoterm2?.code : ''}
                                    </span>
                                  </td>
                                )}
                              </>
                            )}
                            <td className='td-order-3 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                <PopoverText
                                  content={
                                    item['province']?.region_name +
                                    (item['city']?.city_name ? ', ' + item['city']?.city_name : '')
                                  }
                                  index={_index}
                                  className='spec-sliceee'
                                />
                              </span>
                            </td>
                            {sektorID == 1 && (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>{t(item.segment_name)}</span>
                              </td>
                            )}
                            <td className='td-order-3 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                <PopoverText
                                  content={
                                    item?.end_user_multiple
                                      ? handleShowValue(item?.end_user, item?.end_user_multiple)
                                      : item?.end_user
                                  }
                                  index={_index}
                                  className='desc-slicee'
                                />
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {t(item['product_type_desc'])}
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {parseInt(item.material_number) == 0 ? (
                                  <label className='opacity-0'>-</label>
                                ) : (
                                  item['material_number']?.slice(-7)
                                )}
                              </span>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <span className='d-block fs-6 py-3'>{item['product_name']}</span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                <PopoverText
                                  content={item['product_spec'] ? item['product_spec'] : '-'}
                                  index={_index}
                                  className='spec-sliceee'
                                />
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {i18next.language === 'en'
                                  ? parseFloat(item['request_quantum'])?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : parseFloat(item['request_quantum'])?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })}{' '}
                                {item.sector_id === 3 ? 'MT' : 'Ton'}
                              </span>
                            </td>
                            {sektorID != 2 && (
                              <td className='td-order-2 text-center column'>
                                {item['fixed_quantum'] ? (
                                  <span className='d-block fs-6 py-3'>
                                    {(item.status == 4 ||
                                      item.status == 7 ||
                                      item.status == 6 ||
                                      item.status == 8) &&
                                    item.sales_id != null ? (
                                      <>
                                        {i18next.language === 'en'
                                          ? item['fixed_quantum']?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : item['fixed_quantum']?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })}{' '}
                                        {item.sector_id === 3 ? 'MT' : 'Ton'}
                                      </>
                                    ) : (
                                      <label className='opacity-0'>-</label>
                                    )}
                                  </span>
                                ) : (
                                  <label className='opacity-0'>-</label>
                                )}
                              </td>
                            )}
                            {item.is_formulated_price ? (
                              <>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block fs-6 py-3'>{t('Formulated Price')}</span>
                                </td>
                              </>
                            ) : (
                              <>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block fs-6 py-3'>
                                    <>
                                      {(sektorID == 3 ? 'USD' : 'Rp') +
                                        (i18next.language === 'en'
                                          ? parseFloat(item['request_price'])?.toLocaleString(
                                              'en',
                                              {maximumFractionDigits: 4}
                                            )
                                          : parseFloat(item['request_price'])?.toLocaleString(
                                              'id',
                                              {maximumFractionDigits: 4}
                                            )) +
                                        (sektorID == 3 ? '/MT' : '/Ton')}
                                    </>
                                  </span>
                                </td>
                              </>
                            )}

                            {sektorID != 2 && (
                              <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  {(item.status == 4 ||
                                    item.status == 7 ||
                                    item.status == 6 ||
                                    item.status == 8) &&
                                  item.sales_id != null ? (
                                    <>
                                      {(sektorID == 3 ? 'USD' : 'Rp') +
                                        (i18next.language === 'en'
                                          ? item['fixed_price']?.toLocaleString('en', {
                                              maximumFractionDigits: 4,
                                            })
                                          : item['fixed_price']?.toLocaleString('id', {
                                              maximumFractionDigits: 4,
                                            })) +
                                        (sektorID == 3 ? '/MT' : '/Ton')}
                                    </>
                                  ) : (
                                    <label className='opacity-0'>-</label>
                                  )}
                                </span>
                              </td>
                            )}
                            {item.sector_id == 1 && (
                              <>
                                <td className='td-order-2 text-center column'>
                                  <span className='d-block fs-6 py-3'>
                                    {item.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                                  </span>
                                </td>
                              </>
                            )}
                            {item.sector_id == 2 && (
                              <td className='td-order-3 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  <PopoverText
                                    content={item['plant_desc']}
                                    index={_index}
                                    className='spec-sliceee'
                                  />
                                </span>
                              </td>
                            )}
                          </tr>
                        </>
                      )}
                    </tbody>
                  ))}
                </>
              ) : (
                <>
                  {nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202' ? (
                    <>
                      <thead className='border-bottom'>
                        <tr className='fw-bold  d-flex jusify-content-center w-100 align-items-center'>
                          <th className='td-order-1 text-center'>{t('pilih')}</th>
                          <th className='td-order-1 text-center'>{t('sub-order-item')}</th>
                          <th className='td-order-2 text-center'>Status</th>
                          <th className='td-order-4 text-center'>{t('order-aksi')}</th>
                          <th className='td-order-4 text-center'>Sales Org</th>
                          <th className='td-order-2 text-center'>{t('sub-order-incoterm')}</th>
                          {sektorID != 3 ? (
                            <th className='td-order-4 text-center'>{t('sub-order-wilayah')}</th>
                          ) : (
                            ''
                          )}
                          <th className='td-order-3 text-center'>{t('End Customer')}</th>
                          <th className='td-order-2 text-center'>{t('sub-order-jenis')}</th>
                          <th className='td-order-2 text-center'>{t('Product Code')}</th>
                          <th className='td-order-4 text-center'>{t('sub-order-produk')}</th>
                          <th className='td-order-2 text-center'>{t('Kuantum Pengajuan')}</th>
                          <th className='td-order-2 text-center'>{t('Kuantum PengajuanD')}</th>
                          <th className='td-order-2 text-center'>{t('Harga Pengajuan')}</th>
                          <th className='td-order-2 text-center'>{t('sub-order-hargaD')}</th>
                          <th className='td-order-2 text-center'>Status {t('Price')}</th>
                        </tr>
                      </thead>
                      {detailOrder.map((item, _index) => (
                        <tbody key={item?.id ?? _index}>
                          <tr className='d-flex jusify-content-center w-100 align-items-center'>
                            <td className='td-order-1 text-center column'>
                              <div className='d-block py-3' style={{margin: '-1px 0 auto'}}>
                                <input
                                  disabled={item.status == 13 ? false : true}
                                  className='form-check-input'
                                  type='checkbox'
                                  id={'checkbox' + _index}
                                  value={item.id}
                                  onClick={() => onclickCheckBox(_index)}
                                />
                              </div>
                            </td>

                            <td className='td-order-1 text-center column'>
                              <span className='d-block fs-6 py-3'>{_index + 1}</span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {item['status_text'] == 'Pengajuan Amandemen' ||
                                item['status_text'] == 'Amandemen' ||
                                item['status_text'] == 'Diamandemen Customer' ||
                                item['status_text'] == 'Telah Diamandemen' ||
                                item['status_text'] == 'Menunggu Persetujuan Amandemen' ? (
                                  <span className='badge badge-light-info'>{t('Amandemen')}</span>
                                ) : item['status'] == '0' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '1' && item.is_new ? (
                                  <label className='opacity-0'>-</label>
                                ) : item['status'] == '1' ? (
                                  <span className='badge badge-light-primary'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '2' ? (
                                  <span className='badge badge-light-warning'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '3' ? (
                                  <span className='badge badge-light-warning'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '4' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '5' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '6' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '7' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item.status == 'new' ? (
                                  <label className='opacity-0'>-</label>
                                ) : (
                                  <span className='badge badge-light-danger'>
                                    {t(item['status_text'])}
                                  </span>
                                )}
                              </span>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <div
                                className='d-flex justify-content-center align-items-center'
                                style={{margin: '1.2px 0'}}
                              >
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title='Detail'
                                  onClick={() => {
                                    setisAmandment('false')
                                    setTempDetail(item)
                                    setShowDetail(true)
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/file-text-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                <button
                                  onClick={() => {
                                    setisAmandment('false')
                                    setSubOrderID(item.id)
                                    setParam(item.is_new_item ? 'amandemen' : 'order-item')
                                    setFileBox(item)
                                    setDownloadOnly(true)
                                    handleShowAttachment(
                                      item.is_new_item ? 'amandemen' : 'order-item',
                                      item.id
                                    )
                                  }}
                                  hidden={roleUser == 'salesAdmin' ? true : false}
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('order-lampiran')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/archive-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              </div>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <span className='d-block fs-6 py-3'>{item.produsen?.name}</span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>{item.incoterm1?.code}</span>
                            </td>
                            {sektorID != 3 ? (
                              <td className='td-order-4 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                  <PopoverText
                                    content={
                                      item['province']?.region_name + ', ' + item['city']?.city_name
                                    }
                                    index={_index}
                                    className='spec-sliceee'
                                  />
                                </span>
                              </td>
                            ) : (
                              ''
                            )}
                            <td className='td-order-3 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                <PopoverText
                                  content={
                                    item?.end_user_multiple
                                      ? handleShowValue(item?.end_user, item?.end_user_multiple)
                                      : item?.end_user
                                  }
                                  index={_index}
                                  className='desc-slicee'
                                />
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {t(item['product_type_desc'])}
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {parseInt(item.material_number) == 0 ? (
                                  <label className='opacity-0'>-</label>
                                ) : (
                                  item['material_number']?.slice(-7)
                                )}
                              </span>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <span className='d-block fs-6 py-3'>{item['product_name']}</span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {i18next.language === 'en'
                                  ? item['request_quantum']?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : item['request_quantum']?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })}{' '}
                                {item.sector_id === 3 ? 'MT' : 'Ton'}
                              </span>
                            </td>

                            <td className='td-order-2 text-center column'>
                              {item['fixed_quantum'] ? (
                                <span className='d-block fs-6 py-3'>
                                  {item.status == 4 ||
                                  item.status == 7 ||
                                  item.status == 6 ||
                                  item.status == 8 ? (
                                    <>
                                      {i18next.language === 'en'
                                        ? item['fixed_quantum']?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : item['fixed_quantum']?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })}{' '}
                                      {item.sector_id === 3 ? 'MT' : 'Ton'}
                                    </>
                                  ) : (
                                    <label className='opacity-0'>-</label>
                                  )}
                                </span>
                              ) : (
                                <label className='opacity-0'>-</label>
                              )}
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {(sektorID == 3 ? 'USD' : 'Rp') +
                                  (i18next.language === 'en'
                                    ? parseFloat(item['request_price'])?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      })
                                    : parseFloat(item['request_price'])?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      })) +
                                  (sektorID == 3 ? '/MT' : '/Ton')}
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {item.status == 4 ||
                                item.status == 7 ||
                                item.status == 6 ||
                                item.status == 8 ? (
                                  <>
                                    {(sektorID == 3 ? 'USD' : 'Rp') +
                                      (i18next.language === 'en'
                                        ? parseFloat(item['fixed_price'])?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                          })
                                        : parseFloat(item['fixed_price'])?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                          })) +
                                      (sektorID == 3 ? '/MT' : '/Ton')}
                                  </>
                                ) : (
                                  <label className='opacity-0'>-</label>
                                )}
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {item.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </>
                  ) : (
                    <>
                      <thead className='border-bottom'>
                        <tr className='fw-bold  d-flex jusify-content-center w-100 align-items-center'>
                          {roleUser == 'salesAdmin' ? (
                            <th className='td-order-1 text-center'>{t('pilih')}</th>
                          ) : (
                            ''
                          )}
                          <th className='td-order-1 text-center'>{t('sub-order-item')}</th>
                          <th className='td-order-2 text-center'>Status</th>
                          <th className='td-order-4 text-center'>{t('order-aksi')}</th>
                          <th className='td-order-4 text-center'>Sales Org</th>
                          <th className='td-order-2 text-center'>{t('sub-order-jenis')}</th>
                          <th className='td-order-2 text-center'>{t('Product Code')}</th>
                          <th className='td-order-4 text-center'>{t('sub-order-produk')}</th>
                        </tr>
                      </thead>
                      {detailOrder.map((item, _index) => (
                        <tbody key={item?.id ?? _index}>
                          <tr className='d-flex jusify-content-center w-100 align-items-center'>
                            <td className='td-order-1 text-center column'>
                              <div className='d-block py-3' style={{margin: '-1px 0 auto'}}>
                                <input
                                  disabled={item.status == 13 ? false : true}
                                  className='form-check-input'
                                  type='checkbox'
                                  id={'checkbox' + _index}
                                  value={item.id}
                                  onClick={() => onclickCheckBox(_index)}
                                />
                              </div>
                            </td>

                            <td className='td-order-1 text-center column'>
                              <span className='d-block fs-6 py-3'>{_index + 1}</span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {item['status_text'] == 'Pengajuan Amandemen' ||
                                item['status_text'] == 'Amandemen' ||
                                item['status_text'] == 'Diamandemen Customer' ||
                                item['status_text'] == 'Telah Diamandemen' ||
                                item['status_text'] == 'Menunggu Persetujuan Amandemen' ? (
                                  <span className='badge badge-light-info'>{t('Amandemen')}</span>
                                ) : item['status'] == '0' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '1' ? (
                                  <span className='badge badge-light-primary'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '2' ? (
                                  <span className='badge badge-light-warning'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '3' ? (
                                  <span className='badge badge-light-warning'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '4' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '5' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '6' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : item['status'] == '7' ? (
                                  <span className='badge badge-light-success'>
                                    {t(item['status_text'])}
                                  </span>
                                ) : (
                                  <span className='badge badge-light-danger'>
                                    {t(item['status_text'])}
                                  </span>
                                )}
                              </span>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <div
                                className='d-flex justify-content-center align-items-center'
                                style={{marginTop: '3px'}}
                              >
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title='Detail'
                                  onClick={() => {
                                    setisAmandment('false')
                                    setTempDetail(item)
                                    setShowDetail(true)
                                  }}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/file-text-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                                <button
                                  onClick={() => {
                                    setisAmandment('false')
                                    handleShowAttachment(
                                      item.is_new_item ? 'amandemen' : 'order-item',
                                      item.id
                                    )
                                    setSubOrderID(item.id)
                                    setParam(item.is_new_item ? 'amandemen' : 'order-item')
                                    setFileBox(item)
                                    setDownloadOnly(true)
                                  }}
                                  hidden={roleUser == 'salesAdmin' ? true : false}
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('order-lampiran')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/archive-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              </div>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <span className='d-block fs-6 py-3'>{item.produsen?.name}</span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {t(item['product_type_desc'])}
                              </span>
                            </td>
                            <td className='td-order-2 text-center column'>
                              <span className='d-block fs-6 py-3'>
                                {parseInt(item.material_number) == 0 ? (
                                  <label className='opacity-0'>-</label>
                                ) : (
                                  item['material_number']?.slice(-7)
                                )}
                              </span>
                            </td>
                            <td className='td-order-4 text-center column'>
                              <span className='d-block fs-6 py-3'>{item['product_name']}</span>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </>
                  )}
                </>
              )}
            </table>
            {/* End Table Head */}
          </div>

          <div style={{marginTop: '2rem'}}>
            <div className='d-flex justify-content-end mt-5 mb-3'>
              <Link to='/management/order/all' className='me-2'>
                <Button variant='secondary'>
                  {buttonFlag && hakAkses?.approve ? t('Cancel') : t('order-kembali')}
                </Button>
              </Link>

              {buttonFlag && hakAkses?.approve && (
                <>
                  <button className='btn btn-success me-2' id='btn-approve' onClick={handleShow5}>
                    {t('Approve')}
                  </button>
                  <Modal show={show5} onHide={handleClose5} centered backdrop='static'>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                      <h3 className='text-center mb-5'>{t('apakahAndaYakin')}</h3>
                      <div className='d-flex justify-content-center'>
                        <Button variant='secondary me-2' onClick={() => setShow5(false)}>
                          {t('Tidak')}
                        </Button>
                        <Button onClick={handleShow6} disabled={btnLoading}>
                          {btnLoading ? (
                            <Spinner animation='border' variant='light' size='sm' />
                          ) : (
                            t('Ya')
                          )}
                        </Button>
                      </div>
                    </Modal.Body>
                  </Modal>
                </>
              )}
            </div>
          </div>
        </div>

        {/* modal custoemr profile */}
        <Modal
          size='xl'
          show={show2}
          onHide={() => {
            setShow2(false)
            setTotalInvoices([0, 0, 0, 0])
            setInvoices([
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
              {
                B000: 0,
                C000: 0,
                D000: 0,
                E000: 0,
                F000: 0,
              },
            ])
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('Customer Support Data')}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{backgroundColor: '#e9e9f4'}}>
            <Row className='mb-5'>
              <Col sm={6}>
                <div className='card pe-1'>
                  <div className='card-body'>
                    <div className='d-flex align-items-center'>
                      <img src={toAbsoluteUrl(`/media/money 1.png`)} />
                      <h6 className='ms-3' style={{color: '#274070'}}>
                        Outstanding Invoice
                      </h6>
                    </div>
                    <hr />
                    <div className='d-flex justify-content-between'>
                      <p>{'<'}31 Days</p>
                      <p>{totalInvoices[0]}</p>
                    </div>
                    <div className='d-flex justify-content-between bg-secondary'>
                      <p>31-90 Days</p>
                      <p>{totalInvoices[1]}</p>
                    </div>
                    <div className='d-flex justify-content-between'>
                      <p>91-365 Days</p>
                      <p>{totalInvoices[2]}</p>
                    </div>
                    <div className='d-flex justify-content-between bg-secondary'>
                      <p>{'>'}365 Days</p>
                      <p>{totalInvoices[3]}</p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm={6}>
                <div className='card ps-1 '>
                  <div className='card-body'>
                    <div className='d-flex align-items-center'>
                      <img src={toAbsoluteUrl(`/media/search 1.png`)} />
                      <h6 className='ms-3' style={{color: '#274070'}}>
                        Status
                      </h6>
                    </div>
                    <hr />
                    <div className='d-flex justify-content-center align-items-center'>
                      <div
                        className='rounded-circle'
                        style={{
                          width: '80px',
                          height: '80px',
                          backgroundColor: colorList[custStatus.STATUS],
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className='card'>
              <div className='card-body'>
                <Row>
                  <Col sm={6}>
                    <div className='d-flex align-items-center mb-3'>
                      <img src={toAbsoluteUrl(`/media/search 1.png`)} />
                      <h6 className='ms-3' style={{color: '#274070'}}>
                        Data Detail
                      </h6>
                    </div>
                    <div className='card' style={{backgroundColor: '#F4FAFA'}}>
                      <div className='card-body'>
                        <h6 style={{color: '#274070'}}>
                          Customer Title:{' '}
                          <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>
                            {custStatus['CompanyTitle'] ? custStatus['CompanyTitle'] : '-'}
                          </span>
                        </h6>
                        <h6 className='mb-4' style={{color: '#274070'}}>
                          Customer Name:{' '}
                          <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>
                            {custStatus['CustomerName']}
                          </span>
                        </h6>
                        <h6 style={{color: '#274070'}}>
                          Alamat:{' '}
                          <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>
                            {customerAddress}
                          </span>
                        </h6>
                        <h6 style={{color: '#274070'}}>
                          Provinsi: <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>-</span>
                        </h6>
                        <h6 className='mb-10' style={{color: '#274070'}}>
                          Kota/Kab: <span style={{color: '#7F7F7F', fontWeight: 'normal'}}>-</span>
                        </h6>
                        <h6 style={{color: '#274070'}}>Customer Number</h6>
                        <div className='w-50' style={{backgroundColor: 'white'}}>
                          <div className='d-flex justify-content-between align-items-center px-2 border-top border-bottom'>
                            <p>{customerCode}</p>
                            <div
                              className='rounded-circle'
                              style={{
                                width: '12px',
                                height: '12px',
                                backgroundColor:
                                  colorList[custStatus.status ? custStatus.status : 'Yellow'],
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <Row className='mb-5'>
                      <Col sm={6} className='pe-2'>
                        <h4 className='mb-2'>Invoices {'>'} 365 Days</h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[3].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[3].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[3].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[3].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[3].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                      <Col sm={6} className='ps-2'>
                        <h4 className='mb-2' style={{color: '#F0C94A'}}>
                          Invoices 31-90 Days
                        </h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[1].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[1].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[1].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[1].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[1].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6} className='pe-2'>
                        <h4 className='mb-2 text-danger'>Invoices 91-365 Days</h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[2].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[2].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[2].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[2].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[2].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                      <Col sm={6} className='ps-2'>
                        <h4 className='mb-2' style={{color: '#48CE86'}}>
                          Invoices {'<'}30 Days
                        </h4>
                        <h5 className='mb-2' style={{color: '#274070'}}>
                          Company Code
                        </h5>
                        <hr style={{margin: '0'}} />
                        <div className='d-flex justify-content-between'>
                          <p>B000</p>
                          <p>{invoices[0].B000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>C000</p>
                          <p>{invoices[0].C000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>D000</p>
                          <p>{invoices[0].D000}</p>
                        </div>
                        <div className='d-flex justify-content-between bg-secondary'>
                          <p>E000</p>
                          <p>{invoices[0].E000}</p>
                        </div>
                        <div className='d-flex justify-content-between'>
                          <p>F000</p>
                          <p>{invoices[0].F000}</p>
                        </div>
                        <hr style={{margin: '0'}} />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* modal attachment db */}
        <Modal
          size='lg'
          show={showUpload}
          onHide={() => {
            setShowUpload(false)
            setFileBox({})
          }}
          backdrop='static'
          keyboard={false}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {fileBox?.product_name
                ? (fileBox.province ? fileBox.province?.region_name : '') +
                  (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                  (fileBox.province ? ' | ' : '') +
                  fileBox.product_name +
                  (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                : t('File Box')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {allFile.length < 1 || allFile.length == undefined ? (
              <></>
            ) : (
              <div className='table-responsive mt-4 bdr'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='fw-bold border-bottom'>
                    <tr className=''>
                      <th className='text-center'>{t('order-noo')}</th>
                      <th className='text-center'>{t('order-keterangan')}</th>
                      <th className='text-center'>{t('order-tglUpload')}</th>
                      {/* <th className='text-center'>{t('User Code')}</th> */}
                      <th className='text-center'>{t('order-user')}</th>
                      <th className='text-center'>{t('Akses Role')}</th>
                      <th className='text-center'>{t('order-aksi')}</th>
                    </tr>
                  </thead>
                  {allFile.map((data: any, _index: number) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className=''>
                        <td className='text-center'>
                          <label>{_index + 1}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.description}</label>
                        </td>
                        <td className='text-center'>
                          <label>{dateformat(data.updated_at)}</label>
                        </td>
                        {/* <td className='text-center'>
                          <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                        </td> */}
                        <td className='text-center'>
                          {data.user?.customer_code == null ? (
                            <label>{data.user?.name}</label>
                          ) : (
                            <label>{data.user?.customer?.name}</label>
                          )}
                        </td>
                        <td className='text-center'>
                          {data.private ? (
                            data.roles.length > 0 ? (
                              <PopoverText
                                content={handleShowRoleName(data.roles)}
                                index={_index}
                                className='desc-slice'
                              />
                            ) : (
                              'Private'
                            )
                          ) : (
                            'Public'
                          )}
                        </td>
                        <td className='text-center'>
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title={t('unduh')}
                            onClick={() =>
                              handleDownloadAttachment(
                                data.file_path
                              )
                            }
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrow-down-square-fill.svg'
                              className='svg-icon-3'
                            />
                          </button>
                          {(hakAkses?.attachment_delete ||
                            CheckSameIDAttachment(data.user_role_flag)) && (
                            <button
                              onClick={() => deleteAttachment(data.id)}
                              className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                              data-bs-toggle='tooltip'
                              data-bs-placement='top'
                              data-bs-trigger='hover'
                              title={t('Hapus')}
                            >
                              <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                              />
                            </button>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* modal stock */}
        <Modal
          show={showStock}
          onHide={() => setShowStock(false)}
          centered
          size='xl'
          scrollable
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('order-cekStock')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive bdr'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead className='border-bottom'>
                  <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                    <th className='td-order-1 text-center'>{t('Date Create')}</th>
                    <th className='td-order-1 text-center'>{t('Plant')}</th>
                    <th className='td-order-4 text-center'>{t('Plant Description')}</th>
                    <th className='td-order-1 text-center'>{t('Storage Location')}</th>
                    <th className='td-order-2 text-center'>{t('Storage Location Name')}</th>
                    <th className='td-order-1 text-center'>{t('Material Number')}</th>
                    <th className='td-order-4 text-center'>{t('kontrak-nama')}</th>
                    <th className='td-order-1 text-center'>{t('kuantitas')}</th>
                    <th className='td-order-1 text-center'>Unit</th>
                    <th className='td-order-1 text-center'>{t('Valuated Stock')}</th>
                  </tr>
                </thead>
                {allStock.map((data: any, index: number) => (
                  <tbody key={data?.id ?? index}>
                    <tr className='d-flex jusify-content-center w-100 align-items-center'>
                      <td className='td-order-1 text-center'>{data.DATUM.slice(0, 10)}</td>
                      <td className='td-order-1 text-center'>{data.WERKS}</td>
                      <td className='td-order-4 text-center'>{data.NAME1}</td>
                      <td className='td-order-1 text-center'>{data.LGORT}</td>
                      <td className='td-order-2 text-center'>{data.LGOBE}</td>
                      <td className='td-order-1 text-center'>{data.MATNR.slice(10, 19)}</td>
                      <td className='td-order-4 text-center'>{data.MAKTX}</td>

                      {data.STOCK == null || data.STOCK == '' ? (
                        <td className='td-order-1 text-center'>0</td>
                      ) : (
                        <td className='td-order-1 text-center'>
                          {i18next.language === 'en'
                            ? parseFloat(data.STOCK)?.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            : parseFloat(data.STOCK)?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })}
                        </td>
                      )}

                      <td className='td-order-1 text-center'>{data.UNIT}</td>

                      {data.LABST == null || data.LABST == '' ? (
                        <td className='td-order-1 text-center'>0</td>
                      ) : (
                        <td className='td-order-1 text-center'>
                          {i18next.language === 'en'
                            ? parseFloat(data.LABST)?.toLocaleString('en', {
                                maximumFractionDigits: 4,
                              })
                            : parseFloat(data.LABST)?.toLocaleString('id', {
                                maximumFractionDigits: 4,
                              })}
                        </td>
                      )}
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          </Modal.Body>
        </Modal>

        {/* modal detail */}
        <Modal
          show={showDetail}
          onHide={() => {
            setShowDetail(false)
          }}
          centered
          backdrop='static'
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {showPurchaseForm ? (
              <>
                {is_amendment == 'true' ? (
                  <>
                    {tempDetail.sector_id == 1 && (
                      <Row>
                        <Col md='6'>
                          <h5 className='mb-3 text-danger'>{t('Before')}</h5>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>Sales Org</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2?.produsen?.name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={t(tempData2?.sector?.name)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2?.incoterm1?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            <Col md={8}>
                              {tempData2?.incoterm2 == null ? (
                                <Form.Control
                                  value={
                                    tempData2?.incoterm2_id == null ||
                                    tempData2?.incoterm2_id == '0'
                                      ? ''
                                      : tempData2?.incoterm2_id
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              ) : (
                                <Form.Control
                                  value={tempData2?.incoterm2?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempData2.province?.region_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempData2.city?.city_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('segment')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={t(tempData2?.segment_name)}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2.product_type_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2.product_name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                            </Col>
                            <Col md={8}>
                              {tempData2.so_qty_realized == undefined ? (
                                <Form.Control
                                  value={
                                    (i18next.language === 'en'
                                      ? parseFloat(tempData2?.fixed_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : parseFloat(tempData2?.fixed_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })) + (tempData2?.sector_id === 3 ? ' MT' : ' Ton')
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              ) : (
                                <Form.Control
                                  value={
                                    (i18next.language === 'en'
                                      ? (
                                          parseFloat(tempData2.fixed_quantum) -
                                          parseFloat(tempData2.so_qty_realized)
                                        ).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        })
                                      : (
                                          parseFloat(tempData2.fixed_quantum) -
                                          parseFloat(tempData2.so_qty_realized)
                                        ).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        })) + (tempData2?.sector_id === 3 ? ' MT' : ' Ton')
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-2'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/Ton</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  'Rp' + i18next.language === 'en'
                                    ? parseInt(tempData2?.fixed_price).toLocaleString('en') + '/Ton'
                                    : parseInt(tempData2?.fixed_price).toLocaleString('id') + '/Ton'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-4 fs-6'>{t('termasuk-ppn')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Check
                                reverse
                                name='ppn'
                                className='mt-5 mb-2'
                                type='checkbox'
                                id='ckbox-ppn'
                                checked={tempData2?.include_ppn}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Control
                                disabled
                                type='text'
                                size='sm'
                                value={
                                  tempData2?.shipping_tolerance == 0
                                    ? ''
                                    : tempData2?.shipping_tolerance + '%'
                                }
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2?.payment_type_1_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2?.payment_type_2_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              {i18next.language === 'en' ? (
                                <p className='mt-3 fs-6'>{t('keterangan')}</p>
                              ) : (
                                <p className='fs-6'>{t('keterangan')}</p>
                              )}
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2?.payment_note}
                                type='text'
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col md={8}>
                              <FieldProductSpec data={tempData2.product_spec} />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('End Customer')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  tempData2?.end_user_multiple
                                    ? handleShowValue(
                                        tempData2?.end_user,
                                        tempData2?.end_user_multiple
                                      )
                                    : tempData2?.end_user
                                }
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2?.notes}
                                as='textarea'
                                style={{height: '40px'}}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          { tempData?.sector_id != 2 && <Row
                            className='mb-4'
                            hidden={tempData?.amandement_notes == null ? true : false}
                          >
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('alasan perpanjangan')}
                                defaultValue={tempData?.amandement_notes}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row> }
                        </Col>
                        <Col md='6'>
                          <h5 className='mb-3' style={{color: '#2664b5'}}>
                            {t('After')}
                          </h5>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>Sales Org</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData.produsen?.name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={t(tempData.sector?.name)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData.incoterm1?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            <Col md={8}>
                              {tempData?.incoterm2 == null ? (
                                <Form.Control
                                  value={
                                    tempData?.incoterm2_id == null || tempData?.incoterm2_id == '0'
                                      ? ''
                                      : tempData?.incoterm2_id
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              ) : (
                                <Form.Control
                                  value={tempData?.incoterm2?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempData.province?.region_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempData.city?.city_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('segment')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={t(tempData?.segment_name)}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          {/* <Row className='mb-4'>
                    <Col md={4}>
                      <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                    </Col>
                    <Col md={8}>
                      <Form.Control type='text' value={tempData.plant_desc} disabled size='sm' />
                    </Col>
                  </Row> */}
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData.product_type_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData.product_name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? (
                                        parseFloat(tempData.fixed_quantum) -
                                        parseFloat(tempData.so_qty_realized)
                                      )?.toLocaleString('en', {maximumFractionDigits: 4}) + ' Ton'
                                    : (
                                        parseFloat(tempData.fixed_quantum) -
                                        parseFloat(tempData.so_qty_realized)
                                      )?.toLocaleString('id', {maximumFractionDigits: 4}) + ' Ton'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-2'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/Ton</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  'Rp' + i18next.language === 'en'
                                    ? parseInt(tempData?.fixed_price).toLocaleString('en') + '/Ton'
                                    : parseInt(tempData?.fixed_price).toLocaleString('id') + '/Ton'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-4 fs-6'>{t('termasuk-ppn')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Check
                                reverse
                                name='ppn'
                                className='mt-5 mb-2'
                                type='checkbox'
                                id='ckbox-ppn'
                                checked={tempData?.include_ppn}
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Control
                                disabled
                                type='text'
                                size='sm'
                                value={
                                  tempData?.shipping_tolerance == 0
                                    ? ''
                                    : tempData?.shipping_tolerance + '%'
                                }
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData?.payment_type_1_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData?.payment_type_2_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              {i18next.language === 'en' ? (
                                <p className='mt-3 fs-6'>{t('keterangan')}</p>
                              ) : (
                                <p className='fs-6'>{t('keterangan')}</p>
                              )}
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData?.payment_note}
                                type='text'
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col md={8}>
                              <FieldProductSpec data={tempData.product_spec} />
                              <Form.Control
                                value={tempData.product_spec}
                                as='textarea'
                                style={{height: '40px'}}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('End Customer')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  tempData?.end_user_multiple
                                    ? handleShowValue(
                                        tempData?.end_user,
                                        tempData?.end_user_multiple
                                      )
                                    : tempData?.end_user
                                }
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData?.notes}
                                as='textarea'
                                style={{height: '40px'}}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          { tempData.sector_id != 2 && 
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('alasan perpanjangan')}
                                defaultValue={tempData?.amandement_notes}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row> }
                        </Col>
                      </Row>
                    )}

                    {tempDetail.sector_id == 3 && (
                      <Row>
                        <Col md='6'>
                          <h5 className='mb-3 text-danger'>{t('Before')}</h5>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>Sales Org</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2.produsen?.name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={t(tempData2.sector?.name)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2.incoterm1?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            <Col md={8}>
                              {tempData2?.incoterm2 == null ? (
                                <Form.Control
                                  value={
                                    tempData2?.incoterm2_id == null ||
                                    tempData2?.incoterm2_id == '0'
                                      ? ''
                                      : tempData2?.incoterm2_id
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              ) : (
                                <Form.Control
                                  value={tempData2?.incoterm2?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempData2.province?.region_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempData2.city?.city_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2.product_type_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2.product_name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                            </Col>
                            <Col md={8}>
                              {tempData2.so_qty_realized == undefined ? (
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? parseFloat(tempData2?.fixed_quantum).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                      : parseFloat(tempData2?.fixed_quantum).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              ) : (
                                <Form.Control
                                  value={
                                    i18next.language === 'en'
                                      ? (
                                          parseFloat(tempData2.fixed_quantum) -
                                          parseFloat(tempData2.so_qty_realized)
                                        ).toLocaleString('en', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                      : (
                                          parseFloat(tempData2.fixed_quantum) -
                                          parseFloat(tempData2.so_qty_realized)
                                        ).toLocaleString('id', {
                                          maximumFractionDigits: 4,
                                        }) + ' MT'
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/MT</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  'USD' + i18next.language === 'en'
                                    ? parseFloat(tempData2?.fixed_price).toLocaleString('en') +
                                      '/MT'
                                    : parseFloat(tempData2?.fixed_price).toLocaleString('id') +
                                      '/MT'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          {/* <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-4'>{t('termasuk-ppn')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Check
                                reverse
                                disabled
                                name='ppn'
                                className='mt-5 mb-2'
                                type='checkbox'
                                id='ckbox-ppn'
                                checked={tempData2?.include_ppn}
                              />
                            </Col>
                          </Row> */}
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Control
                                disabled
                                type='text'
                                size='sm'
                                value={
                                  tempData2?.shipping_tolerance == 0
                                    ? ''
                                    : tempData2?.shipping_tolerance + '%'
                                }
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2?.payment_type_1_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2?.payment_type_2_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='mt-3 fs-6'>{t('keterangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2?.payment_note}
                                type='text'
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col md={8}>
                              <FieldProductSpec data={tempData2.product_spec} />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('End Customer')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  tempData2?.end_user_multiple
                                    ? handleShowValue(
                                        tempData2?.end_user,
                                        tempData2?.end_user_multiple
                                      )
                                    : tempData2?.end_user
                                }
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData2?.notes}
                                as='textarea'
                                style={{height: '40px'}}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          { tempData?.sector_id != 2 &&
                          <Row
                            className='mb-4'
                            hidden={tempData?.amandement_notes == null ? true : false}
                          >
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('alasan perpanjangan')}
                                defaultValue={tempData?.amandement_notes}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row> }
                        </Col>
                        <Col md='6'>
                          <h5 className='mb-3' style={{color: '#2664b5'}}>
                            {t('After')}
                          </h5>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>Sales Org</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData.produsen?.name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={t(tempData.sector?.name)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData.incoterm1?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            <Col md={8}>
                              {tempData?.incoterm2 == null ? (
                                <Form.Control
                                  value={
                                    tempData?.incoterm2_id == null || tempData?.incoterm2_id == '0'
                                      ? ''
                                      : tempData?.incoterm2_id
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              ) : (
                                <Form.Control
                                  value={tempData?.incoterm2?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempData.province?.region_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempData.city?.city_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData.product_type_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData.product_name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? (
                                        parseFloat(tempData.fixed_quantum) -
                                        parseFloat(tempData.so_qty_realized)
                                      )?.toLocaleString('en', {maximumFractionDigits: 4}) + ' MT'
                                    : (
                                        parseFloat(tempData.fixed_quantum) -
                                        parseFloat(tempData.so_qty_realized)
                                      )?.toLocaleString('id', {maximumFractionDigits: 4}) + ' MT'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Harga Pengajuan')}/MT</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  'USD' + i18next.language === 'en'
                                    ? parseFloat(tempData?.fixed_price).toLocaleString('en') + '/MT'
                                    : parseFloat(tempData?.fixed_price).toLocaleString('id') + '/MT'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          {/* <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-4'>{t('termasuk-ppn')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Check
                                reverse
                                name='ppn'
                                disabled
                                className='mt-5 mb-2'
                                type='checkbox'
                                id='ckbox-ppn'
                                checked={tempData?.include_ppn}
                              />
                            </Col>
                          </Row> */}
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Control
                                disabled
                                type='text'
                                size='sm'
                                value={
                                  tempData?.shipping_tolerance == 0
                                    ? ''
                                    : tempData?.shipping_tolerance + '%'
                                }
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData?.payment_type_1_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData?.payment_type_2_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='mt-3 fs-6'>{t('keterangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData?.payment_note}
                                type='text'
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col md={8}>
                              <FieldProductSpec data={tempData.product_spec} />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('End Customer')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  tempData?.end_user_multiple
                                    ? handleShowValue(
                                        tempData?.end_user,
                                        tempData?.end_user_multiple
                                      )
                                    : tempData?.end_user
                                }
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempData?.notes}
                                as='textarea'
                                style={{height: '40px'}}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          { tempData?.sector_id != 2 &&
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                placeholder={t('alasan perpanjangan')}
                                defaultValue={tempData?.amandement_notes}
                                disabled
                                id='note'
                                size='sm'
                                style={{height: '40px'}}
                              />
                            </Col>
                          </Row> }
                        </Col>
                      </Row>
                    )}
                  </>
                ) : (
                  <>
                    {tempDetail?.sector_id == 1 && (
                      <Row>
                        <Col md='6'>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>Sales Org</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.produsen?.name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.incoterm1?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempDetail.province?.region_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.product_type_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? parseFloat(tempDetail?.fixed_quantum).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) + ' Ton'
                                    : parseFloat(tempDetail?.fixed_quantum).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) + ' Ton'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6'>{t('Shipping Tolerance')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                // placeholder={t('Shipping Tolerance')}
                                size='sm'
                                type='text'
                                id='shipping'
                                value={
                                  tempDetail?.shipping_tolerance == 0
                                    ? ''
                                    : tempDetail?.shipping_tolerance + '%'
                                }
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail?.payment_type_1_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('keterangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail?.payment_note}
                                type='text'
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='fs-6 mt-3'>{t('segment')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={t(tempDetail?.segment_name)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('End Customer')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  tempDetail?.end_user_multiple
                                    ? handleShowValue(
                                        tempDetail?.end_user,
                                        tempDetail?.end_user_multiple
                                      )
                                    : tempDetail?.end_user
                                }
                                as='textarea'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col md='6'>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={t(tempDetail.sector?.name)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            <Col md={8}>
                              {tempDetail?.incoterm2 == null ? (
                                <Form.Control
                                  value={
                                    tempDetail?.incoterm2_id == null ||
                                    tempDetail?.incoterm2_id == '0'
                                      ? ''
                                      : tempDetail?.incoterm2_id
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              ) : (
                                <Form.Control
                                  value={tempDetail?.incoterm2?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempDetail.city?.city_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.product_name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-2'>
                            <Col md={4}>
                              <p className='fs-6'>{t('Harga Pengajuan')}/Ton</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  'Rp' + i18next.language === 'en'
                                    ? parseInt(tempDetail?.fixed_price).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) + '/Ton'
                                    : parseInt(tempDetail?.fixed_price).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) + '/Ton'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>

                          <Row className='my-7'>
                            <Col sm={6} className='d-flex'>
                              <Row sm={8} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('termasuk-ppn')}</p>
                              </Row>
                              <Row
                                sm={4}
                                className='d-flex justify-content-start align-items-center ms-4'
                              >
                                <Form.Check
                                  reverse
                                  name='ppn'
                                  type='checkbox'
                                  id='ckbox-ppn'
                                  checked={tempDetail?.include_ppn}
                                />
                              </Row>
                            </Col>

                            <Col sm={6} className='d-flex'>
                              <Row sm={8} className='d-flex align-items-center'>
                                <p className='fs-6'>{t('Formulated Price')}</p>
                              </Row>
                              <Row
                                sm={4}
                                className='d-flex justify-content-start align-items-center ms-4'
                              >
                                <Form.Check
                                  reverse
                                  name='formula_Price'
                                  type='checkbox'
                                  id='formula_Price'
                                  checked={tempDetail?.is_formulated_price}
                                />
                              </Row>
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail?.payment_type_2_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col md={8}>
                              <FieldProductSpec data={tempDetail.product_spec} />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                as='textarea'
                                style={{height: '40px'}}
                                value={tempDetail?.notes}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )}

                    {tempDetail?.sector_id == 3 && (
                      <Row>
                        <Col md='6'>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>Sales Org</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.produsen?.name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.incoterm1?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempDetail.province?.region_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.product_type_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? tempDetail?.fixed_quantum.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) +
                                      ' ' +
                                      'MT'
                                    : tempDetail?.fixed_quantum.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) +
                                      ' ' +
                                      'MT'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col sm={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('Shipping Tolerance')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                size='sm'
                                type='text'
                                id='shipping'
                                value={
                                  tempDetail?.shipping_tolerance == 0
                                    ? ''
                                    : tempDetail?.shipping_tolerance + '%'
                                }
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail?.payment_type_1_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('keterangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail?.payment_note}
                                type='text'
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('End Customer')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  tempDetail?.end_user_multiple
                                    ? handleShowValue(
                                        tempDetail?.end_user,
                                        tempDetail?.end_user_multiple
                                      )
                                    : tempDetail?.end_user
                                }
                                as='textarea'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col md='6'>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={t(tempDetail.sector?.name)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            <Col md={8}>
                              {tempDetail?.incoterm2 == null ? (
                                <Form.Control
                                  value={
                                    tempDetail?.incoterm2_id == null ||
                                    tempDetail?.incoterm2_id == '0'
                                      ? ''
                                      : tempDetail?.incoterm2_id
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              ) : (
                                <Form.Control
                                  value={tempDetail?.incoterm2?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempDetail.city?.city_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.product_name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>

                          <Row className='mb-2'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6 mt-3'>{t('Harga Pengajuan')}/MT</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  'USD' + i18next.language === 'en'
                                    ? parseFloat(tempDetail?.fixed_price).toLocaleString('en', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2,
                                      })
                                    : parseFloat(tempDetail?.fixed_price).toLocaleString('id', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2,
                                      })
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-4'>{t('Formulated Price')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Check
                                reverse
                                name='formula_Price'
                                className='mt-5 mb-2'
                                type='checkbox'
                                id='formula_Price'
                                checked={tempDetail?.is_formulated_price}
                              />
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail?.payment_type_2_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col md={8}>
                              <FieldProductSpec data={tempDetail.product_spec} />
                            </Col>
                          </Row>

                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail?.notes}
                                as='textarea'
                                style={{height: '40px'}}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )}

                    {tempDetail?.sector_id == 2 && (
                      <Row>
                        <Col md='6'>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>Sales Org</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.produsen?.name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.incoterm1?.code}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempDetail.province?.region_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.plant_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.product_name}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('Kuantum Pengajuan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  i18next.language === 'en'
                                    ? tempDetail?.fixed_quantum.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) +
                                      ' ' +
                                      'Ton'
                                    : tempDetail?.fixed_quantum.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) +
                                      ' ' +
                                      'Ton'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail?.payment_type_1_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('keterangan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail?.payment_note}
                                type='text'
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col md='6'>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={t(tempDetail.sector?.name)}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                            </Col>
                            <Col md={8}>
                              {tempDetail?.incoterm2 == null ? (
                                <Form.Control
                                  value={
                                    tempDetail?.incoterm2_id == null ||
                                    tempDetail?.incoterm2_id == '0'
                                      ? ''
                                      : tempDetail?.incoterm2_id
                                  }
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              ) : (
                                <Form.Control
                                  value={tempDetail?.incoterm2?.code}
                                  type='text'
                                  disabled
                                  size='sm'
                                />
                              )}
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                type='text'
                                value={tempDetail.city?.city_name}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail.product_type_desc}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('sub-order-spek')}</p>
                            </Col>
                            <Col md={8}>
                              <FieldProductSpec data={tempDetail.product_spec} />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='fs-6 mt-3'>{t('Price')}/Ton</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  'Rp' + i18next.language === 'en'
                                    ? parseInt(tempDetail?.fixed_price).toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                      }) + '/Ton'
                                    : parseInt(tempDetail?.fixed_price).toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                      }) + '/Ton'
                                }
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('End Customer')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={
                                  tempDetail?.end_user_multiple
                                    ? handleShowValue(
                                        tempDetail?.end_user,
                                        tempDetail?.end_user_multiple
                                      )
                                    : tempDetail?.end_user
                                }
                                as='textarea'
                                style={{height: '40px'}}
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                          <Row className='mb-4'>
                            <Col md={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                            </Col>
                            <Col md={8}>
                              <Form.Control
                                value={tempDetail?.notes}
                                as='textarea'
                                style={{height: '40px'}}
                                type='text'
                                disabled
                                size='sm'
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {nonpenjualan == 'INF-201' || nonpenjualan == 'INF-202' ? (
                  <Row>
                    <Col md={6}>
                      <Row className='mb-3'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={tempDetail.produsen?.name}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>Incoterm</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={tempDetail?.incoterm1?.code}
                            type='text'
                            size='sm'
                            disabled
                          />
                        </Col>
                      </Row>

                      {tempDetail?.sector_id != 3 ? (
                        <>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                type='text'
                                size='sm'
                                value={tempDetail?.province?.region_name}
                                disabled
                              />
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ''
                      )}

                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={tempDetail.product_type_desc}
                            type='text'
                            size='sm'
                            disabled
                          />
                        </Col>
                      </Row>

                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('Kuantum Pengajuan')}</p>
                        </Col>
                        <Col sm={8}>
                          <InputGroup size='sm'>
                            <Form.Control
                              value={
                                (i18next.language === 'en'
                                  ? parseFloat(tempDetail?.fixed_quantum).toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : parseFloat(tempDetail?.fixed_quantum).toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })) + (tempDetail?.sector_id != 3 ? ' Ton' : ' MT')
                              }
                              type='text'
                              size='sm'
                              disabled
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row
                        className='mb-3'
                        hidden={
                          regarding == 'PO002' &&
                          roleUser == 'salesAdmin' &&
                          (tempDetail.status == 1 || tempDetail.status == 0)
                            ? false
                            : true
                        }
                      >
                        <Col sm={4}>
                          <p className='mt-3 fs-6'>{t('Kuantum PengajuanD')}</p>
                        </Col>
                        <Col sm={8}>
                          <InputGroup size='sm'>
                            <CurrencyInput
                              defaultValue={
                                tempDetail.fixed_quantum2 ? tempDetail.fixed_quantum2 : ''
                              }
                              placeholder={t('Kuantum PengajuanD')}
                              className='form-control form-control-sm'
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                setQuantumApp(value?.replace(/,/g, '.'))
                              }}
                              decimalsLimit={3}
                            />
                            <InputGroup.Text id='basic-addon2'>
                              {tempDetail?.sector_id != 3 ? 'Ton' : 'MT'}
                            </InputGroup.Text>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('End Customer')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={
                              tempDetail?.end_user_multiple
                                ? handleShowValue(
                                    tempDetail?.end_user,
                                    tempDetail?.end_user_multiple
                                  )
                                : tempDetail?.end_user
                            }
                            as='textarea'
                            style={{height: '40px'}}
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={t(tempDetail.sector?.name)}
                            type='text'
                            disabled
                            size='sm'
                          />
                        </Col>
                      </Row>
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={tempDetail?.notes}
                            as='textarea'
                            size='sm'
                            style={{height: '40px'}}
                            disabled
                          />
                        </Col>
                      </Row>
                      {tempDetail?.sector_id != 3 ? (
                        <>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                            </Col>
                            <Col sm={8}>
                              <Form.Control
                                type='text'
                                size='sm'
                                value={tempDetail?.city?.city_name}
                                disabled
                              />
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ''
                      )}
                      <Row className='mb-4'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>{t('sub-order-produk')}</p>
                        </Col>
                        <Col sm={8}>
                          <Form.Control
                            value={tempDetail.product_name}
                            type='text'
                            size='sm'
                            disabled
                          />
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>
                            {t('Harga Pengajuan')}/{tempDetail.sector_id == 3 ? 'MT' : 'Ton'}
                          </p>
                        </Col>
                        <Col sm={8}>
                          {tempDetail.sector_id != 3 ? (
                            <Form.Control
                              value={
                                'Rp' + i18next.language === 'en'
                                  ? parseInt(tempDetail?.request_price).toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    }) + '/Ton'
                                  : parseInt(tempDetail?.request_price).toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    }) + '/Ton'
                              }
                              type='text'
                              size='sm'
                              disabled
                            />
                          ) : (
                            <Form.Control
                              value={
                                'USD' + i18next.language === 'en'
                                  ? parseFloat(tempDetail?.request_price).toLocaleString('en', {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    }) + '/MT'
                                  : parseFloat(tempDetail?.request_price).toLocaleString('id', {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    }) + '/MT'
                              }
                              type='text'
                              size='sm'
                              disabled
                            />
                          )}
                        </Col>
                      </Row>
                      <Row
                        className='mb-3'
                        hidden={
                          regarding == 'PO002' &&
                          roleUser == 'salesAdmin' &&
                          (tempDetail.status == 1 || tempDetail.status == 0)
                            ? false
                            : true
                        }
                      >
                        <Col sm={4}>
                          <p className='fs-6 mt-3'>
                            {t('sub-order-hargaD')}/{tempDetail.sector_id == 3 ? 'MT' : 'Ton'}
                          </p>
                        </Col>
                        <Col sm={8}>
                          <InputGroup size='sm'>
                            <InputGroup.Text id='basic-addon2'>
                              <span className='px-1'>
                                {tempDetail.sector_id == 3 ? 'USD' : 'Rp'}
                              </span>
                            </InputGroup.Text>
                            <CurrencyInput
                              defaultValue={tempDetail.fixed_price2 ? tempDetail.fixed_price2 : ''}
                              placeholder={t('sub-order-hargaD')}
                              className='form-control form-control-sm'
                              decimalSeparator={language === 'en' ? '.' : ','}
                              groupSeparator={language === 'en' ? ',' : '.'}
                              onValueChange={(value: any) => {
                                setSubpriceApp(value?.replace(/,/g, '.'))
                              }}
                              decimalsLimit={tempDetail.sector_id == 3 ? 2 : -1}
                            />
                          </InputGroup>
                        </Col>
                      </Row>

                      {tempDetail?.sector_id != 3 ? (
                        <>
                          <Row className='mb-4'>
                            <Col sm={4}>
                              <p className='fs-6 mt-3'>{t('termasuk-ppn')}</p>
                            </Col>
                            <Col sm={8} className='d-flex justify-content-start'>
                              <Form.Check
                                reverse
                                name='ppn'
                                className='mt-3 mb-2'
                                type='checkbox'
                                id='ckbox-ppn'
                                checked={tempDetail.include_ppn}
                              />
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                ) : (
                  <>
                    <Row className='mb-3'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('kontrak-produsen')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          value={tempDetail.produsen?.name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-3'>
                      <Col sm={4}>
                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          value={t(tempDetail.sector?.name)}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-jenis')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          value={tempDetail.product_type_desc}
                          type='text'
                          size='sm'
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='mt-4 fs-6'>{t('sub-order-produk')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          value={tempDetail.product_name}
                          type='text'
                          size='sm'
                          disabled
                        />
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col sm={4}>
                        <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                      </Col>
                      <Col sm={8}>
                        <Form.Control
                          value={tempDetail?.notes}
                          as='textarea'
                          size='sm'
                          style={{height: '40px'}}
                          disabled
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}
          </Modal.Body>
        </Modal>

        {/* modal jadwal dari db */}
        <Modal
          show={showJadwal}
          onHide={() => {
            setShowJadwal(false)
            sessionStorage.removeItem('isCustomer')
          }}
          centered
          size='xl'
          backdrop='static'
          keyboard={false}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {sektorID != 3 ? provinceDesc + ', ' + cityDesc + ' | ' : ''}
              {pname} | {fixedQuantum2} Ton
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span style={{fontSize: '15px'}} className='fw-bold d-block'>
              {t('Jadwal')}
            </span>
            {allJadwal.length < 1 ? (
              <div className='text-center fs-4 fw-semibold'>{t('no schedule')}</div>
            ) : (
              <div className='table-responsive bdr mt-2'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead className='border-bottom'>
                    <tr className='fw-bold '>
                      <th className='text-center'>{t('order-pengambilan')}</th>
                      <th className='text-center'>{t('order-tanggal')}</th>
                      <th className='text-center'>{t('order-minggu')}</th>
                      <th className='text-center'>{t('order-bulan')}</th>
                      <th className='text-center'>{t('order-tahun')}</th>
                      <th className='text-center'>{t('order-tonase')}</th>
                    </tr>
                  </thead>
                  {allJadwal.map((data, _index) => (
                    <tbody key={data?.id ?? _index}>
                      <tr className=''>
                        <td className='text-center'>
                          <label>{_index + 1}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.date}</label>
                        </td>
                        <td className='text-center'>
                          <label>
                            {t('Week')} {Math.ceil(data.date / 7)}
                          </label>
                        </td>
                        <td className='text-center'>
                          <label>{t(bulan[data.month - 1])}</label>
                        </td>
                        <td className='text-center'>
                          <label>{data.year}</label>
                        </td>
                        <td className='text-center'>
                          <label>
                            {(i18next.language === 'en'
                              ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                              : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                              ' ' +
                              'Ton'}
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </>
  )
}

export {ApprovalOrderDetail}
